import { connect } from 'react-redux';
import React, { Component } from 'react';

import DocView from './DocView';
import {browserHistory} from 'react-router';

import {http_methods} from '../utils';
import {spec_validator} from '../spec_utils';

class SpecEditor extends Component {
  shouldComponentUpdate(newProps) {
    return this.props.spec !== newProps.spec;
  }
  render() {
    const {api, spec, onUpdateSpec, onUpdatePath} = this.props;

    return <DocView
      content={spec}
      validator={spec_validator}
      onPathChange={path => onUpdatePath({api, path})}
      onValidatedChange={onUpdateSpec}
    />;
  }
}

export default connect(
  state => {
    const api = state.getIn(['apis', 'selected', 'api']);
    const spec = state.getIn(['apis', 'raw', api]);
    return {
      api,
      spec
    };
  },
  dispatch => (
    {
      onUpdateSpec(data) {
        dispatch({type: 'UPDATE_SPEC', data});
      },
      onUpdatePath({api, path}) {
        // TODO: figure out whether we want to navigate based on editor paths or not
        return;

        try {
          const route = path.filter(part => part.startsWith('/'));
          const method = path.filter(part => http_methods[part]);
          const hash = method.length === 1 ? `#${method[0]}` : '';
          const url = `/${api}${route.join('')}${hash}`;
          browserHistory.push(url);
        }
        catch(err) {
          // TODO: determine logic for handling route errors in the spec
        }
      }
    }
  )
)(SpecEditor);
